<template>
<v-flex class="py-3 px-2" xs12 sm8 md6 lg4>
  <v-card class="pa-3 elevation-2">
    <div class="text-xs-center">
      <div class="pb-3 headling">Sign Out</div>
      <p class="title">Are you sure?</p>
      <v-btn @click.native="signOut" color="error" large depressed>
        <b>Sign Out</b>
      </v-btn>
      <v-btn @click.native="leave" color="error" large flat>
        <b>Cancel</b>
      </v-btn>
    </div>
  </v-card>
</v-flex>
</template>

<script>
export default {
  data: () => ({
    entering: true
  }),
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) this.entering = false
      else {
        appMsg.msg = 'You are not signed in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/')
      }
    },
    signOut () {
      this.$store.dispatch('signOut').then(() => {
        const appMsg = {
          type: 'success',
          msg: 'Signed out'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      })
      this.$router.push('/')
    },
    leave () {
      if (this.$store.getters.userRoute === '') this.$router.push('/')
      else this.$router.push(this.$store.getters.userRoute)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/SignOut.vue